var EmailFormTextInputView, EmailFormTextLineInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

EmailFormTextLineInputView = (function(superClass) {
  extend(EmailFormTextLineInputView, superClass);

  function EmailFormTextLineInputView() {
    return EmailFormTextLineInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextLineInputView.prototype.tagName = 'li';

  EmailFormTextLineInputView.prototype.events = {
    'keyup .text_line_input': 'validateEmailForm'
  };

  EmailFormTextLineInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".text_line_input";
    return this.template = {
      text_line_input_template: true
    };
  };

  return EmailFormTextLineInputView;

})(EmailFormTextInputView);

module.exports = EmailFormTextLineInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvY29tbW9uL3ZpZXdzL3RleHRfbGluZV9pbnB1dF92aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2NvbW1vbi92aWV3cy90ZXh0X2xpbmVfaW5wdXRfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxrREFBQTtFQUFBOzs7QUFBQSxzQkFBQSxHQUF5QixPQUFBLENBQVEsbUJBQVI7O0FBRW5COzs7Ozs7O3VDQUNKLE9BQUEsR0FBUzs7dUNBRVQsTUFBQSxHQUNFO0lBQUEsd0JBQUEsRUFBMEIsbUJBQTFCOzs7dUNBRUYsVUFBQSxHQUFZLFNBQUE7SUFDVixzQkFBc0IsQ0FBQSxTQUFFLENBQUEsVUFBVSxDQUFDLEtBQW5DLENBQXlDLElBQXpDLEVBQStDLFNBQS9DO0lBQ0EsSUFBQyxDQUFBLFNBQUQsR0FBYTtXQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7TUFBQyx3QkFBQSxFQUEwQixJQUEzQjs7RUFIRjs7OztHQU4yQjs7QUFXekMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
